import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, setupAdmin } from '../../lib/api';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { Toaster } from '../ui/sonner';
import { LOGO_SRC } from '../../lib/branding';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });

  useEffect(() => {
    // Check if already logged in
    const token = localStorage.getItem('admin_token');
    if (token) {
      navigate('/admin/dashboard');
    }
    
    // Setup admin on first load
    setupAdmin().catch(() => {});
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await login(credentials.username, credentials.password);
      localStorage.setItem('admin_token', response.data.access_token);
      toast.success('Login successful');
      navigate('/admin/dashboard');
    } catch (err) {
      const message =
        err?.response?.data?.detail || 'Invalid username or password';
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen charcoal-gradient flex items-center justify-center p-4" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_SRC} alt="Silver Perfumes" className="h-16 mx-auto mb-4" />
          <h1 className="text-2xl font-serif text-white">Admin Portal</h1>
        </div>

        <div className="bg-white p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username" className="label-text">Username</Label>
              <Input
                id="username"
                type="text"
                value={credentials.username}
                onChange={(e) => {
                  setCredentials({ ...credentials, username: e.target.value });
                  if (error) setError('');
                }}
                required
                className="input-luxury"
                placeholder="Enter username"
                data-testid="admin-username"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="label-text">Password</Label>
              <Input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => {
                  setCredentials({ ...credentials, password: e.target.value });
                  if (error) setError('');
                }}
                required
                className="input-luxury"
                placeholder="Enter password"
                data-testid="admin-password"
              />
            </div>

            {error && (
              <p className="text-sm text-red-600" data-testid="admin-login-error" role="alert">
                {error}
              </p>
            )}

            <Button
              type="submit"
              disabled={loading}
              className="btn-primary w-full"
              data-testid="admin-login-btn"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
        </div>
      </div>
      <Toaster position="top-right" />
    </div>
  );
}
